import { removeNulls } from 'utils/Object.utils';

import investorDeductionsReducer, {
  type InvestorDeductionsState,
} from './portfolio.investorDeductions.reducer';

type ReducerAction = {
  type?: string;
  [key: string]: any;
};

export type Investor = {
  id?: string;
  deductions?: InvestorDeductionsState;
  [key: string]: any;
};

export type InvestorsState = Record<string, any>;

const initialState: InvestorsState = {};

const investorsReducer = (
  state: InvestorsState = initialState,
  action: ReducerAction
): InvestorsState => {
  switch (action.type) {
    case 'INVESTOR_PROFILES_ADD_NEW': {
      const { investor } = action;
      return {
        ...state,
        [investor.id]: investor,
      };
    }
    case 'INVESTOR_PROFILES_UPDATE': {
      const { investor } = action;
      return {
        ...state,
        [investor.id]: investor,
      };
    }
    case 'INVESTOR_PROFILES_DELETE': {
      const { investorId } = action;
      return removeNulls({
        ...state,
        [investorId]: null,
      }) as InvestorsState;
    }
    default: {
      const { investorId } = action;
      const investor = state[investorId];
      if (investor) {
        return {
          ...state,
          [investorId]: {
            ...investor,
            deductions: investorDeductionsReducer(investor.deductions, action),
          },
        };
      }
      return state;
    }
  }
};
export default investorsReducer;
